import React, { memo } from 'react';
import { Button } from 'antd';
import { PlusOutlined, MinusOutlined } from '@ant-design/icons';
import { isValid } from '../../utils/utilities';

const GridCell = memo(({ rowIndex, colIndex, isHighlighted, isSelected, onHover, onClick, onMouseLeave, gridId }) => (
    <div
        className={`grid-cell ${isHighlighted ? 'highlighted' : ''} ${isSelected ? 'selected' : ''}`}
        onMouseEnter={() => onHover(rowIndex, colIndex, gridId)}
        onMouseLeave={onMouseLeave}
        onClick={() => onClick(rowIndex, colIndex, gridId)}
    />
));

const GridRow = memo(({ rowIndex, hoveredCell, selectedTable, onHover, onClick, onMouseLeave, gridId }) => (
    <div className="grid-row">
        <div className="row-number">{rowIndex + 1}</div>
        {Array(7).fill().map((_, colIndex) => (
            <GridCell
                key={`${rowIndex}-${colIndex}`}
                rowIndex={rowIndex}
                colIndex={colIndex}
                isHighlighted={hoveredCell && rowIndex <= hoveredCell.row && colIndex <= hoveredCell.col && hoveredCell.gridId === gridId}
                isSelected={isValid(selectedTable) && isValid(selectedTable[gridId]) && rowIndex < selectedTable[gridId].rows && colIndex < selectedTable[gridId].cols}
                onHover={onHover}
                onClick={onClick}
                onMouseLeave={onMouseLeave}
                gridId={gridId}
            />
        ))}
    </div>
));

export const GridLayout = ({ grid, gridId, hoveredCell, selectedTable, onHover, onClick, onMouseLeave }) => {
    return (
        <>
            <div className="grid-container">
                <div className="column-numbers">
                    {Array(7).fill().map((_, index) => (
                        <div key={index} className="column-number">{index + 1}</div>
                    ))}
                </div>
                {Array(12).fill().map((_, rowIndex) => (
                    <GridRow
                        key={rowIndex}
                        rowIndex={rowIndex}
                        hoveredCell={hoveredCell}
                        selectedTable={selectedTable}
                        onHover={onHover}
                        onClick={onClick}
                        onMouseLeave={onMouseLeave}
                        gridId={gridId}
                    />
                ))}
            </div>
            <div className="selected-table-info">
                {hoveredCell && hoveredCell.gridId === gridId ? 
                    `Selected size: ${hoveredCell.row + 1} x ${hoveredCell.col + 1}` :
                    isValid(selectedTable) && isValid(selectedTable[gridId]) ? 
                        `Current selection: ${selectedTable[gridId].rows} x ${selectedTable[gridId].cols}` : 
                        'Select a size'
                }
            </div>
        </>
    );
}; 